module.exports = __webpack_public_path__ + "static/media/heart.823a34b3.svg";